import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import { handleNumericalFieldChange } from "@services/ErrorHandling";
import { USER } from "@types/user";

type UserCompanyNumberCardProps = {
  userData: USER;
  updateUserData: (field: string, value: any) => void;
  errors: any;
  updateError: (field: string, value: any) => void;
};

export const UserCompanyNumberCard = ({
  userData,
  updateUserData,
  errors,
  updateError,
}: UserCompanyNumberCardProps) => {
  return (
    <div>
      <TextInputField
        label="社員番号"
        value={userData?.employee_number}
        placeholder="123456"
        onChange={(e) =>
          handleNumericalFieldChange(
            "employee_number",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.employee_number && (
        <p className="text-red-500">
          {UserFieldErrorMessages.employeeNumberError}
        </p>
      )}
      <div className="mt-5 divider"></div>
    </div>
  );
};
